import React from "react";

const Loader = ({
  isVisible,
  loadingText = "Loading...",   // make text customizable
}) => {
  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center backdrop-blur-md bg-white/30 space-y-4"
      role="status"              // accessibility
      aria-live="polite"
    >
      {/* Loader Spinner */}
      <div className="relative w-24 h-24">
        {/* Gradient ring */}
        <div
          className="absolute inset-0 rounded-full border-8 border-t-transparent animate-spin"
          style={{
            borderImage:
              "conic-gradient(#355E32, #E4C48D, #00B5C9, #355E32) 1",
            borderStyle: "solid",
            animationDuration: "2s",    // smoother custom speed
          }}
        ></div>

        {/* Center star */}
        <svg
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-pulse"
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="url(#grad1)"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: "#355E32" }} />
              <stop offset="100%" style={{ stopColor: "#00B5C9" }} />
            </linearGradient>
          </defs>
          <path d="M12 2L14.85 8.54L22 9.27L16.9 14.14L18.2 21.02L12 17.77L5.8 21.02L7.1 14.14L2 9.27L9.15 8.54L12 2Z" />
        </svg>
      </div>

      {/* Loading Text */}
      <div className="text-2xl font-extrabold text-[#355E32] drop-shadow-sm tracking-wide">
        {loadingText}
      </div>
    </div>
  );
};

export default Loader;
